import angular from 'angular';
import GridUtils from '~/components/kform/utils/kform-grid-utils';
import template from './well.html';
import fbtemplate from './builder/preview.html';
import WellComponent from './well.component';

const wellConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('well', {
		title:      'Well',
		template,
		group:      'layout',
		selectable: true,
		settings:   new WellComponent(),
		/**
		 * @param {any} data
		 * @param {any} options
		 * @returns {string}
		 */
		tableView(data, options) {
			let view = '<table class="table table-striped table-bordered table-child">';

			if (!options.tableChild) {
				view += '<thead><tr>';
				view += `<th>Well (${options.component.key})</th>`;
				view += '</tr></thead>';
			}
			view += '<tbody>';
			for (const component of options.component.components) {
				view += `<tr>${GridUtils.columnForComponent(data, {
					component,
					$interpolate:  options.$interpolate,
					componentInfo: options.componentInfo,
					tableChild:    true,
					util:          options.util,
				})}</tr>`;
			}

			view += '</tbody></table>';
			return view;
		},
		fbtemplate,
		icon:          'fa fa-square-o',
		noDndOverlay:  true,
		confirmRemove: true,
		views:         [
			{
				name:     'Display',
				template: 'kform/components/well/display.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
	});
};

export default angular.module('app')
	.config(wellConfig);
